import PropTypes from 'prop-types';
import Translations from '../../../../../utils/Translations';
import VXButton from '../../../../SimpleElements/VXButton/VXButton';
import { VXButtonLineConfig, VXButtonLineStyle } from '../../../../SimpleElements/VXButton/VXButtonConfig';
import { COLOR_TYPE_TRANSPARENT } from '../../../../SimpleElements/VXButton/ButtonHelper';
import STYLES from '../../../../SimpleElements/VXButton/EnumVXButton';

const NeedVipOverlay = (props) => (
	<div className="grid-2__tile__restrictions -abo">
		<i className="icon -icon-person-vip" />
		<h3 className="text">{props.text}</h3>
		<VXButton
			onClick={() => {}}
			color={COLOR_TYPE_TRANSPARENT}
			border={STYLES.BORDER.OUTLINE}
			line1={[new VXButtonLineConfig(props.btnText, new VXButtonLineStyle([STYLES.COLORS.WHITE]))]}
		/>
	</div>
);

NeedVipOverlay.propTypes = {
	text: PropTypes.string,
	btnText: PropTypes.string,
};

NeedVipOverlay.defaultProps = {
	text: Translations.get('Grid2RestrictionNeedVip'),
	btnText: Translations.get('Grid2RestrictionBecomeVip'),
};

export default NeedVipOverlay;
